import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  src: string
}

const ImagePreview = ({ src }: Props): ReactElement => {
  return (
    <div className="image-preview-component">
      <img src={src} />
    </div>
  )
}

export default ImagePreview
